"use strict";
module.exports = ['$http', 'ngDroUAACommon', 'ngDroProfile', 'ngDroPerson', 'ngDroRole', 'ngDroGroup', 'ngDroCompany', 'ngDroAudit', 'ngDroTemplate',
    function ($http, ngDroUAACommon, ngDroProfile, ngDroPerson, ngDroRole, ngDroGroup, ngDroCompany, ngDroAudit, ngDroTemplate) {

        this.requireToken = function (username, password, usePrefix) {
            this.login(username, password, usePrefix);
        };

        this.login = function (username, password, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || false);

            var params = {
                "username": username,
                "password": password
            };

            return $http({
                method: 'POST',
                url: ngDroUAACommon.getUrl('api/login'),
                withCredentials: true,
                sendErrors: false,
                data: params
            });
        };

        this.logout = function (usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || false);

            return $http({
                method: 'POST',
                withCredentials: true,
                sendErrors: false,
                url: ngDroUAACommon.getUrl('api/logout')
            });
        };

        this.Profile = ngDroProfile;

        this.Person = ngDroPerson;

        this.Role = ngDroRole;

        this.Group = ngDroGroup;

        this.Company = ngDroCompany;

        this.Audit = ngDroAudit;

        this.Template = ngDroTemplate;
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/UAA.js
// module id = 400
// module chunks = 0